// @flow

import React from 'react';

import Button from 'client/components/button/button';
import Translate from 'client/components/translate';
import type { RouterType } from 'types/react-router.flow';

import LifeQuoteFormContainer from './lifeQuoteFormContainer';
import '../styles/life.scss';
import '../styles/lifeQuote.scss';

type Props = {
  router: RouterType,
  location: {
    action: string,
  },
};

const lifeValueProps = [
  {
    imgSrc:
      'https://images.contentful.com/heg7gyzix6dq/5OtkQkMHNCmkyWgAEqmm4Q/d9f10f9f10eb2cd710fbdd538674dbed/family.svg',
    alt: 'family',
    headerPath: 'life.props.header.family',
    textPath: 'life.props.text.family',
  },
  {
    imgSrc:
      'https://images.contentful.com/heg7gyzix6dq/2CoCOva6Wcwwy6akgiIu2w/a590edcc269333879f9db5b61b49ec17/money.svg',
    alt: 'income',
    headerPath: 'life.props.header.debt',
    textPath: 'life.props.text.debt',
  },
  {
    imgSrc:
      'https://images.contentful.com/heg7gyzix6dq/5bCQwUJSBiKGqMU8Sg88yo/8a4baa7e884a2c43da1db33e95969af8/savings.svg',
    alt: 'savings',
    headerPath: 'life.props.header.savings',
    textPath: 'life.props.text.savings',
  },
];

class LifePage extends React.Component<Props> {
  shouldComponentUpdate(nextProps: Object) {
    // Don't re-render for router sanitizing of query params in lifeForm.
    // This only happens once. Probably an over-optimization!
    if (nextProps.location.action === 'REPLACE' && this.props.location.action === 'POP') {
      return false;
    }

    return true;
  }

  render() {
    const benefitsSection = (
      <section className="life-value-props">
        <div className="value-prop-header row text-center pad-top pad-bottom margin-bottom-2">
          <h2 className="light">
            <Translate path="life.valueProp" />
          </h2>
        </div>
        <div className="row">
          {lifeValueProps.map(benefit => (
            <div className="column medium-4 pad-y pad-x" key={benefit.imgSrc}>
              <div className="benefit">
                <div>
                  <img src={benefit.imgSrc} alt={benefit.alt} className="life-prop-image" />
                </div>
                <h3 className="pad-top">
                  <Translate path={benefit.headerPath} />
                </h3>
                <div className="pad-top-half">
                  <Translate path={benefit.textPath} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    );

    return (
      <div className="vision-landing">
        <div className="life-quote">
          <div className="hero-container">
            <div className="hero">
              <div className="hero-contain">
                <div className="column medium-8 hero-text">
                  <div>
                    <h1 className="hero-header">
                      <span>
                        <Translate path="life.hero.header" />
                      </span>
                    </h1>
                    <h4 className="hero-subheader hide-for-small-only">
                      <Translate path="life.hero.subheader" />
                    </h4>
                  </div>
                </div>
                <img
                  className="column medium-3 hero-image hide-for-small-only"
                  alt="life hero"
                  width={178}
                  height={160}
                  src="https://images.contentful.com/heg7gyzix6dq/5OtkQkMHNCmkyWgAEqmm4Q/d9f10f9f10eb2cd710fbdd538674dbed/family.svg" />
              </div>
            </div>
          </div>

          <LifeQuoteFormContainer router={this.props.router} benefitsSection={benefitsSection} />

          <div className="checkmarks-section">
            <div className="row text-center grey-3-color bold">
              <Translate path="life.benefits.question" />
            </div>
            <div className="row text-center pad">
              <h3>
                <Translate path="life.benefits.answer" />
              </h3>
            </div>
            <div className="checkmarks row flex-row wrap text-left large-8">
              {['mortgage', 'tuition', 'expenses', 'burial', 'debt', 'bills'].map(key => (
                <div className="checkmark column medium-4 pad" key={key}>
                  <span aria-hidden className="icon-check-mark-circle green-color bold">
                    {' '}
                  </span>
                  <Translate path={`life.benefits.${key}`} />
                </div>
              ))}
            </div>
            <div className="pad-top weight-600">
              <Translate path="life.benefits.other" />
            </div>
          </div>

          <div className="stride-life text-center pad-top-3">
            <div className="cobranding-logo pad-bottom-2 pad-top">
              <img
                className="stride-logo-img light loading logo-left"
                src="https://images.ctfassets.net/heg7gyzix6dq/7o82sRo0qm5wUd1nCG9QXI/8c3e3e1c1f72f62e383c195814055300/stride_cobrand_logo.png?h=45"
                alt="Stride Health logo" />
              <img
                className="logo-right"
                alt="stride life logo"
                src="https://images.ctfassets.net/heg7gyzix6dq/4tv0Xj1zsZgeK8XNvQBRUP/f171cc03021810acee8c7212eae2625a/ladder_logo.png?h=45" />
            </div>
            <div className="center-col">
              <h3 className="life-header pad">
                <Translate path="life.ladder.partnership" />
              </h3>
              <h4 className="life-subheader pad">
                <Translate path="life.ladder.policies" />
              </h4>
              <div className="life-cta pad-top-2 pad-bottom-2">
                <Button
                  className="primary ede-cta"
                  clickHandler={(e) => {
                    e.preventDefault();
                    const quotesTop = document.getElementById('quotes-top');
                    if (quotesTop) {
                      quotesTop.scrollIntoView();
                    }
                  }}>
                  <Translate path="life.getQuote" />
                </Button>
              </div>
              <div className="pad-top">
                <img
                  alt="family"
                  src="https://images.contentful.com/heg7gyzix6dq/6bskqrVHNKQGumUCGueKcy/41a83393d9904059d6da9d8b030adad0/life-family.svg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LifePage;
